var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-btn',{attrs:{"color":"primary","outlined":""},on:{"click":function($event){return _vm.downloadFile('csv')}}},[_vm._v(" CSV ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }